import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, EnvelopeSimple } from 'phosphor-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-stone-50 noise-texture">
      <div className="max-w-2xl mx-auto px-6 py-12">
        <Link
          to="/landing"
          className="inline-flex items-center gap-2 text-stone-600 hover:text-primary transition-colors mb-8"
          data-testid="back-home-link"
        >
          <ArrowLeft size={20} />
          Back to Home
        </Link>

        <h1 className="text-4xl font-serif font-semibold text-stone-800 mb-6" data-testid="contact-title">
          Contact Us
        </h1>

        <div className="bg-white rounded-2xl p-8 shadow-sm">
          <div className="flex items-start gap-4 mb-6">
            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <EnvelopeSimple size={24} weight="duotone" className="text-primary" />
            </div>
            <div>
              <h2 className="text-xl font-serif font-semibold text-stone-800 mb-2">
                Get in Touch
              </h2>
              <p className="text-stone-600 leading-relaxed">
                We're here to help with questions about AraVela, privacy concerns, or technical issues.
              </p>
            </div>
          </div>

          <a
            href="mailto:support@aravela.app"
            className="inline-flex items-center gap-2 bg-primary text-white rounded-full px-8 py-4 font-medium hover:shadow-soft transition-all duration-300 active:scale-95"
            data-testid="email-link"
          >
            <EnvelopeSimple size={20} weight="duotone" />
            support@aravela.app
          </a>

          <p className="text-sm text-stone-500 mt-4">
            We typically respond within 24–48 hours.
          </p>

          <div className="mt-8 pt-8 border-t border-stone-200">
            <h3 className="font-medium text-stone-800 mb-3">Before You Reach Out</h3>
            <ul className="space-y-2 text-sm text-stone-600">
              <li>• We cannot recover forgotten passcodes or encrypted data</li>
              <li>• For mental health crises, please call 988 (US) or your local emergency services</li>
              <li>• Check our <Link to="/privacy" className="text-primary hover:underline">Privacy Policy</Link> for data questions</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;